/**
 * @file Loading.tsx
 *
 * @fileoverview Shows that a section is being generated by AI.
 */

import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box } from '~/vcl/atoms/07-box';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import Spacing from '~/vcl/atoms/06-layout/07-spacing';
import { Text } from '~/vcl/atoms/13-text/03-text';
import { LoadingCircleIcon } from '~/vcl/icons/LoadingCircle';

/**
 * Stands in for a section while the AI writes it.
 *
 * Shown in the visual editor only, in the place the section occupies, so the
 * wait is visible where the content will appear rather than only on the
 * Generate button in the form beside it. It is replaced as soon as the
 * generation ends, whether it produced content or not.
 */
export const AiGeneratedSiteParagraphLoading = () => {
  const intl = useIntl();

  return (
    <Box
      boxShadow="none"
      borderRadius="0px"
      margin={0}
      padding={0}
      backgroundColorOverride="var(--color-gray0)"
    >
      <Main>
        <Spacing
          paddingTop={8}
          paddingBottom={8}
          marginTop={0}
          marginBottom={0}
        >
          <FlexItems
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap={3}
          >
            <LoadingCircleIcon
              color="primary"
              height="64"
              width="64"
              title={intl.formatMessage({
                id: 'loading_message',
                defaultMessage: 'Loading',
              })}
            />
            <Text tag="p" fontWeight="bold" textAlign="center">
              <FormattedMessage
                id="ai_generated_section_loading"
                defaultMessage="Writing this section with AI…"
              />
            </Text>
            <Text tag="p" color="gray5" textAlign="center">
              <FormattedMessage
                id="ai_generated_section_loading_hint"
                defaultMessage="This takes a few seconds. The section appears here as soon as it is ready."
              />
            </Text>
          </FlexItems>
        </Spacing>
      </Main>
    </Box>
  );
};

export default AiGeneratedSiteParagraphLoading;
